import * as z from 'zod/mini'
import { activityFields } from '../../schemas/activity'
import { ActivityStatus } from '../../types'

/** An activity URL (`.../activities/:activityId`), looked up by `ActivityGuard` within the premise. */
export const activityParams = z.object({ activityId: z.uuid() })
export type ActivityParams = z.infer<typeof activityParams>

const activityBodyFields = {
  name: activityFields.name,
  color: activityFields.color,
  /** Resolved within the premise in `ActivityService`; an id from elsewhere is a 404. */
  placeIds: z.array(z.uuid()),
  /** Resolved within the premise in `ActivityService`; an id from elsewhere is a 404. */
  employeeIds: z.array(z.uuid()),
  enableIndividualEvents: z.optional(activityFields.enableIndividualEvents),
  enableReservations: z.optional(activityFields.enableReservations),
}

export const createActivityBody = z.object(activityBodyFields)
export type CreateActivityBody = z.infer<typeof createActivityBody>

export const editActivityBody = z.partial(z.object(activityBodyFields))
export type EditActivityBody = z.infer<typeof editActivityBody>

export const setActivityStatusBody = z.object({ status: z.enum(ActivityStatus) })
export type SetActivityStatusBody = z.infer<typeof setActivityStatusBody>
